import React, { useEffect, useState } from 'react';
import { Alert, Space, Button } from 'antd';
import { WarningOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { useTenant } from '../contexts/TenantContext';
import api from '../services/api';

interface UsageItem {
  metric: string;
  count: number;
  limit: number;
}

const METRIC_LABELS: Record<string, string> = {
  calculations: '计算次数',
  patients: '本月患者数',
  ai_queries: 'AI查询',
  reports: '报告数',
};

const QuotaAlert: React.FC = () => {
  const { currentTenant } = useTenant();
  const navigate = useNavigate();
  const [warnings, setWarnings] = useState<UsageItem[]>([]);

  useEffect(() => {
    if (!currentTenant) return;
    api.get('/api/subscriptions/usage')
      .then(res => {
        const items: UsageItem[] = res.data?.usage || [];
        setWarnings(items.filter(u => u.limit > 0 && u.count >= u.limit * 0.8));
      })
      .catch(() => {});
  }, [currentTenant]);

  if (!warnings.length) return null;

  const atLimit = warnings.filter(w => w.count >= w.limit);
  const nearLimit = warnings.filter(w => w.count < w.limit);

  return (
    <Space direction="vertical" style={{ width: '100%', marginBottom: 16 }}>
      {atLimit.map(w => (
        <Alert
          key={w.metric}
          type="error"
          showIcon
          icon={<WarningOutlined />}
          message={`${METRIC_LABELS[w.metric] || w.metric}已达上限 (${w.count}/${w.limit})`}
          action={<Button size="small" type="primary" onClick={() => navigate('/subscription')}>升级套餐</Button>}
        />
      ))}
      {nearLimit.map(w => (
        <Alert
          key={w.metric}
          type="warning"
          showIcon
          message={`${METRIC_LABELS[w.metric] || w.metric}即将达到上限 (${w.count}/${w.limit})`}
          action={<Button size="small" onClick={() => navigate('/subscription')}>查看套餐</Button>}
        />
      ))}
    </Space>
  );
};

export default QuotaAlert;
